export enum settingPage {
  BASICINFO,
  WORKFLOW,
  RULECONDITION,
}

export enum settingPageRule {
  FIRSTPAGE,
  SECONDPAGE,
}

